import { useLogoStore } from "../state/logoStore";
import { PageLabel } from "../components/ui/PageLabel";

/**
 * Poster Tiler — hosts the standalone Vision Looky Poster Tiler tool
 * (public/poster-tiler.html) inside a full-height iframe. The tool is a
 * self-contained HTML + canvas app, so embedding it keeps it working exactly
 * as authored while still living as a page in the LOGOMAN PRO nav (reachable
 * from the top dock, right after QR Maker).
 */
export function PosterTilerPage() {
  const setPage = useLogoStore((s) => s.setPage);
  return (
    <div className="page poster-tiler" style={{ minHeight: "100vh", background: "#f5f7fb" }}>
      <PageLabel name="POSTER TILER" />
      <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 16px" }}>
        <button
          type="button"
          onClick={() => setPage("start")}
          style={{
            background: "#062b63",
            color: "#fff",
            border: 0,
            borderRadius: 9,
            padding: "8px 16px",
            fontWeight: 800,
            cursor: "pointer",
          }}
        >
          ← Back
        </button>
      </div>
      <iframe
        src="/poster-tiler.html?v=2"
        title="Vision Looky Poster Tiler"
        style={{ width: "100%", height: "calc(100vh - 56px)", border: 0, display: "block" }}
      />
    </div>
  );
}
